import React, { useEffect } from 'react';
import { useState } from 'react'
import Footer from "../../MyComponents/Footer";
// import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from './HeroContent';
import leftimgs from "../../assets/businessleftimg.png"
import rightimgs from "../../assets/businessrightimg.png"
// import kidimg from "../../assets/kidimg.png"
// import digitalimg from "../../assets/digitalimg.png"
// import funimg from "../../assets/funimg.png"
// import Eimg from "../../assets/Eimg.png"
// import CourseExplorer from '../../MyComponents/CourseExplorer';
import Testimonials from '../../MyComponents/Testimonials';
import FAQs from '../../MyComponents/FooterPages/newfaq';
import HeadSection from "../HeadSection.js";
import pencilIcon from "../../assets/pencil.png";
import API_CONFIG from "../../config/api";

import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { Link } from "react-router-dom";
// import img1 from "../../assets/Business Course/Rectangle 5.png"
// import img2 from "../../assets/Business Course/Rectangle 5-1.png"
// import img3 from "../../assets/Business Course/Group 28.png"
// import img4 from "../../assets/Business Course/Rectangle 5-2.png"

// import icon1 from "../../assets/Business Course/tdesign_user-business-filled.png"
// import icon2 from "../../assets/Business Course/nimbus_marketing.png"
// import icon3 from "../../assets/Business Course/material-symbols_finance-mode-rounded.png"
// import icon4 from "../../assets/Business Course/Vector.png"
import { Helmet } from "react-helmet";
const courses = [
  {
    title: "KidPrenur",
    image: "Polymath-images/Business Course/Rectangle 5.jpg",
    icon: "Polymath-images/Business Course/tdesign_user-business-filled.png",
    color: "#e41595ff",
    age: "Age: 12+",
    link: "/business_kidpreneur"
  },
  {
    title: "Digital Marketing (Coming Soon)",
    image: "Polymath-images/Business Course/Rectangle 5-1.jpg",
    icon: "Polymath-images/Business Course/nimbus_marketing.png",
    color: "#9956bbff",
    age: "Age: 12+",
    // link: "/comm_comm_skills"
  },
  {
    title: "Fun Finance (Coming Soon)",
    image: "Polymath-images/Business Course/Group 28.png",
    icon: "Polymath-images/Business Course/material-symbols_finance-mode-rounded.png",
    color: "#14a8b3ff",
    age: "Age: 12+",
    // link: "/graphic_designing_corel" 
  },
  {
    title: "E-Commerce (Coming Soon)",
    image: "Polymath-images/Business Course/Rectangle 5-2.png",
    icon: "Polymath-images/Business Course/Vector.png",
    color: "#e41595ff",
    age: "Age: 12+",
    // link: "/coding_web_development"
  }


];
const BusinessPopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <>
      <Helmet>
        <title>Entrepreneurship Courses for Kids & Teens (Ages 9-16) | Polymath-Kids</title>
        <meta name="description" content="Unlock your child's creativity with Polymath-Kids entrepreneurship courses. Fun, practical programs in business, digital marketing, finance & e-commerce." />
      </Helmet>

      <div className="stem-container">
        <h1 className="stem-title-1">Explore Our Fun & Skill-Boosting </h1>
        <h1 className="stem-title">Business Courses</h1>
        <div className="courses-grid">
          {courses.map((course) => (
            <div key={course.title} className="course-card">
              <Link to={course.link} className="course-link">

                <div className="course-image-container">
                  <img
                    src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                    alt={course.title}
                    className="course-image"
                  />
                  <span className="ages-badge">{course.age}</span>
                </div>

                <div className="icon-container" style={{ backgroundColor: course.color }}>
                  <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
                </div>

                <p className="course-title">{course.title}</p>
              </Link>
            </div>
          ))}
        </div>
        <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
          <img src={`${API_CONFIG.IMAGES_URL}/Polymath-images/pencil.png`} alt="icon" className="pobtn-icon" />
          Book Free Demo Class
        </button>
      </div>
    </>
  );
};


const BusinessPortal = () => {
  const businesspage = heroContent.businesspage;
  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={"Polymath-images/businessleftimg.png"}
        rightImg={"Polymath-images/businessrightimg.png"}
        titlePart1="Empowering Young Minds"
        titlePart2="Through Entrepreneurship"
        description="Encouraging kids to think of creative ways of doing things mean helping them come up with great business ideas. Polymath-Kids Business courses are especially designed for kids and teens (aged 9 to 16) to equip them with the knowledge required to navigate stages of Entrepreneurship with confidence."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={"Polymath-images/pencil.png"}
        button2Icon={"Polymath-images/pencil.png"}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />
      <BusinessPopularCourses />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
}
export default BusinessPortal